module.exports = __webpack_public_path__ + "static/media/ehealth_latest_news_banner_desktop.664a24ad.jpg";